import React from 'react';
import { CookiesStorageService } from '@/services/cookiesStorageService';
import { generateClientId } from '@/helpers/generateClientId';
import { getTrafficSource } from '@/helpers/getTrafficSource';
import { getUrlParams } from '@/helpers/getUrlParams';
import { sendAllUserDataToWeb } from '@/helpers/sendAllUserDataToWeb';
import { COOKIES_KEYS } from '@/constants/cookiesKeys';
import { GOOGLE_ID } from '@/constants/googleEvents';
import { useMounted } from './useMounted';

export const useInitUserTrackingWeb = (
	doItOnce: React.MutableRefObject<boolean>,
) => {
	const mounted = useMounted();
	const { gclid, msclkid, fbclid } = getUrlParams();

	React.useEffect(() => {
		if (!mounted) return;
		const gclidCookie = CookiesStorageService.get(GOOGLE_ID.GCLID, '');
		const uetmsclkidCookie = CookiesStorageService.get(
			COOKIES_KEYS.UETMSCLKID,
			'',
		);
		const fbclidCookie = CookiesStorageService.get(COOKIES_KEYS.FBCLID, '');
		if (gclid && !gclidCookie) {
			CookiesStorageService.set(GOOGLE_ID.GCLID, gclid);
		}
		if (msclkid && !uetmsclkidCookie) {
			CookiesStorageService.set(COOKIES_KEYS.UETMSCLKID, msclkid);
		}
		if (fbclid && !fbclidCookie) {
			CookiesStorageService.set(COOKIES_KEYS.FBCLID, fbclid);
		}

		const MAX_ATTEMPTS = 10; // ~5s ceiling so a blocked pixel never stalls us
		let attempts = 0;
		const interval = setInterval(() => {
			attempts += 1;
			const traffic = getTrafficSource();
			const clientId = generateClientId();
			const fbp = CookiesStorageService.get<string>('_fbp', '');

			// Wait for whichever pixel is expected to write its identifier; if a
			// pixel is gated out by traffic source it will never produce one, so
			// treat it as already-ready.
			const googleReady = !traffic.allowGoogle || !!clientId;
			const fbReady = !traffic.allowFacebook || !!fbp;
			const timedOut = attempts >= MAX_ATTEMPTS;

			if ((googleReady && fbReady) || timedOut) {
				if (doItOnce.current) {
					doItOnce.current = false;
					sendAllUserDataToWeb('landing_shown');
				}
				clearInterval(interval);
			}
		}, 500);

		return () => clearInterval(interval);
	}, [mounted, doItOnce]);
};
